import { render, staticRenderFns } from "./drawItem.vue?vue&type=template&id=159ce650&scoped=true&"
import script from "./drawItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./drawItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./drawItem.vue?vue&type=style&index=0&id=159ce650&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ce650",
  null
  
)

export default component.exports